import { GET_REVIEWS_URL } from 'api/LocalApiEndpoints';

export const fetchReviews = async (): Promise<ReviewsResponse> => {
  const sheetId = '1rvWnKQJowMVvkgTP8ob9OeOXibSD1SXJ7VjD5tjbSkA';
  const googleApiKey = 'AIzaSyDXqwnyRQ-ZYvokc0ocRQLX_V7AbYSF49M';
  const range = 'Sheet1';
  const baseUrl = 'https://sheets.googleapis.com/v4/spreadsheets';

  const url = `${baseUrl}/${sheetId}/values/${range}?alt=json&key=${googleApiKey}`;

  const res = await fetch(url, {
    next: { revalidate: 3600 },
    headers: { Referer: 'https://www.jabra.com/' },
  });

  return await res.json();
};

export const fetchReviewsWithNext = async (): Promise<ReviewItem[]> => {
  const res = await fetch(GET_REVIEWS_URL);
  const reviewsResponse: ReviewsResponse = await res.json();

  return (reviewsResponse ?? []).values.map((value) => {
    const [
      familyId,
      locale,
      language,
      user,
      productName,
      rate,
      wouldRecommend,
      reviewTitle,
      reviewText,
    ] = value;

    return {
      familyId: +familyId,
      locale,
      language,
      user,
      productName,
      rate: +rate,
      wouldRecommend,
      reviewTitle,
      reviewText,
    };
  });
};

export interface ReviewsResponse {
  range: string;
  majorDimension: string;
  values: string[][];
}

export interface ReviewItem {
  familyId: number;
  locale: string;
  language: string;
  user: string;
  productName: string;
  rate: number;
  wouldRecommend: string;
  reviewTitle: string;
  reviewText: string;
}
